import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "./Layout";

class Body extends Component {
  render() {
    return <Layout {...this.props} type="Body" />;
  }
}

Body.propTypes = {
  childOf: PropTypes.string
};

Body.defaultProps = {
  childOf: "root",
  values: {
    backgroundColor: "#e7e7e7",
    backgroundImage: {
      url: ""
    },
    fullheight: true,
    width: {
      type: "%",
      contentWidth: 100
    },
    contentWidth: "100%"
  }
};

export default Body;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Body.js